import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectMatch } from '../../features/match/matchSlice';
import { FormattedMessage } from 'react-intl';
import { DebounceInput } from 'react-debounce-input';
import StyledLog from './StyledLog';
import ls from 'localstorage-slim';

const RequestLog: React.FC = () => {
  const match = useSelector(selectMatch);
  const [log, setLog] = useState('');

  const key = `${match.id}.log`;

  useEffect(() => {
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  useEffect(() => {
    const storedLog = ls.get(key) as string;
    setLog(storedLog);
  }, [key]);

  const onStorage = () => {
    const storedLog = ls.get(key) as string;
    setLog(storedLog);
  };

  const handleSave = () => {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(log));
    element.setAttribute('download', `${match.id}.log`);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  };

  return (
    <StyledLog>
      <div className="tabs">
        <div className="tab active">
          <FormattedMessage id="requestLog.title" />
        </div>
      </div>
      <div className="content">
        <DebounceInput value={log ? log : ''} onChange={() => {}} element="textarea" readOnly={true} />
      </div>
      <div className="buttonRow">
        <button onClick={handleSave}>
          <FormattedMessage id="requestLog.saveToFile" />
        </button>
      </div>
    </StyledLog>
  );
};

export default RequestLog;
